webpackJsonp([27535781569577],{

/***/ 1048:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---workshops-a0e39f21c11f6a62c5ab.js